// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__FgLDn","horizontalScroll":"Table_horizontalScroll__vQWjR"};